import { useIntl } from 'react-intl';

import messages from './messages';
import { CitationText, ContentWrapper, Grid, QuoteText, Wrapper } from './styles';

const Quote = () => {
	const { formatMessage } = useIntl();
	return (
		<Wrapper>
			<Grid>
				<ContentWrapper>
					<QuoteText>{formatMessage(messages.quote)}</QuoteText>
					<CitationText>{formatMessage(messages.quoteCitation)}</CitationText>
				</ContentWrapper>
			</Grid>
		</Wrapper>
	);
};

export default Quote;
